/**
 * Eski test senkronunda Firestore’a yazılmış geçici Trendyol marka ID’si.
 * Ürün kaydında kalsa bile payload / readiness tarafında yok sayılır; config fallback kullanılır.
 */
export const DEPRECATED_TEST_TRENDYOL_BRAND_ID = 12345;

export function rejectDeprecatedTestTrendyolBrandId(raw) {
  const s = String(raw ?? '').trim();
  if (!s) return '';
  const n = Number(String(s).replace(/,/g, '.'));
  if (Number.isFinite(n) && Math.trunc(n) === DEPRECATED_TEST_TRENDYOL_BRAND_ID) return '';
  return s;
}
